/* eslint-disable react/forbid-elements */
import * as React from 'react';

export const DiscountIcon = () => (
  <svg width="58" height="58" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity=".6" d="M29 58c16.016 0 29-12.984 29-29S45.016 0 29 0 0 12.984 0 29s12.984 29 29 29z" fill="#fff" />
    <path d="M38.75 44a5.25 5.25 0 100-10.5 5.25 5.25 0 000 10.5z" fill="#FF1F34" />
    <path
      d="M44 38.734a5.266 5.266 0 11-10.531 0 5.266 5.266 0 0110.531 0zm-9.839 0a4.573 4.573 0 109.147 0 4.573 4.573 0 00-9.147 0z"
      fill="url(#discount_paint0_angular)"
    />
    <path d="M38.88 14.88L14.882 38.877l4.243 4.243 24-24-4.243-4.242z" fill="#FF1F34" />
    <path d="M38.876 14.877l-23.999 24 2.2 2.199 23.998-24-2.199-2.199z" fill="url(#discount_paint1_linear)" />
    <path d="M19.25 24.5a5.25 5.25 0 100-10.5 5.25 5.25 0 000 10.5z" fill="#FF1F34" />
    <defs>
      <radialGradient
        id="discount_paint0_angular"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(90 0 38.734) scale(5.26562)"
      >
        <stop offset=".111" stopColor="#FF2035" />
        <stop offset=".382" stopColor="#fff" />
        <stop offset=".606" stopColor="#FF1F34" />
      </radialGradient>
      <linearGradient id="discount_paint1_linear" x1="27" y1="27" x2="28.749" y2="28.75" gradientUnits="userSpaceOnUse">
        <stop stopColor="#fff" stopOpacity=".49" />
        <stop offset=".214" stopColor="#fff" stopOpacity=".79" />
        <stop offset=".38" stopColor="#fff" stopOpacity=".702" />
        <stop offset=".84" stopColor="#fff" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

DiscountIcon.displayName = 'DiscountIcon';
